import { render, staticRenderFns } from "./commonTable.vue?vue&type=template&id=36191448&scoped=true&"
import script from "./commonTable.vue?vue&type=script&lang=js&"
export * from "./commonTable.vue?vue&type=script&lang=js&"
import style0 from "./commonTable.vue?vue&type=style&index=0&id=36191448&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36191448",
  null
  
)

export default component.exports